import { SettingFilled, SettingOutlined } from "@ant-design/icons";
import { Drawer, Collapse, Typography, Divider, Space, Tag } from "antd";

const { Panel } = Collapse;
const { Text, Paragraph, Title } = Typography;


export const PricingInfoDrawer = ({ onClose }: any) => {
  return (
    <Drawer
      title="Información Técnica de Precios"
      width={800}
      onClose={onClose}
      open={true}
    >
      <Space direction="vertical" style={{ width: '100%' }}>            

          <h2 style={{color:'SteelBlue', fontWeight:'bold'}}>Factores</h2>
            <Paragraph>            
              <Text strong style={{color:'SteelBlue'}}><Tag color='blue'>param</Tag> Margen_de_beneficio </Text> % de beneficio que se quiere tener con la venta del producto
            </Paragraph>
            <Paragraph>            
              <Text strong style={{color:'SteelBlue'}}><Tag color='blue'>param</Tag> Valor_Numismático </Text> Sobrecoste de un producto debido al valor numismático, incrementando el precio del valor del producto por el peso del metal
            </Paragraph>
            <Paragraph>            
              <Text strong style={{color:'SteelBlue'}}><Tag color='blue'>param</Tag> Oferta </Text> Descuento que se ofrece en la web en relación al precio base del producto, por defecto no hay descuento 
            </Paragraph>            
            <Paragraph>            
              <Text strong style={{color:'SteelBlue'}}><Tag color='blue'>inventario</Tag>Coste_Medio </Text> Media del coste de los artículos actuales de un producto. 
            </Paragraph>
            <Paragraph>
              <Text strong style={{color:'SteelBlue'}}><Tag color='blue'>mercado</Tag>Cotización_metal </Text> Precio que tiene una onza en el mercado
            </Paragraph>
            <Paragraph>
              <Text strong style={{color:'SteelBlue'}}><Tag color='blue'>param</Tag> Factor_Peso </Text> Regula el sobrecoste en piezas pequeñas (ej: es más caro el total de vender 1000 lingotes de 1 gramo que uno de 1 KG).
            </Paragraph>            
            <Paragraph>
              Con todo esto tenemos: <code><b>Valor_metal</b> = Cotización_metal * peso_onzas * factor_peso</code>.
            </Paragraph>
          <h2 style={{color:'SteelBlue', fontWeight:'bold'}}>Precio</h2>
          <Tag color='purple'>
            <code><b>Precio</b> = valor_numismatico + valor_metal * (100% +  Margen_de_beneficio)</code>
          </Tag>
                      
          <Paragraph type="secondary" italic>
            Nota: Partiendo de este precio: <code><b>Precio_mínimo</b> = valor_numismatico + coste_medio * (100% +  Margen_de_beneficio)</code>. Se pondrá este Precio_mínimo si es el valor es más alto que el precio anterior basado en la cotización
          </Paragraph>                                              
          <h2 style={{color:'SteelBlue', fontWeight:'bold'}}>Impuestos</h2>
          <Paragraph>
              <Text strong style={{color:'SteelBlue'}}>IVA </Text> Impuesto sobre el valor añadido, 21% para cualquier producto a excepción del oro y piezas de menos de menos de 1 gramo.              
            </Paragraph>                      
      </Space>
    </Drawer>
  );
};